import React, { useEffect, useState } from "react";
import "./categoryName.css";

const NEIGHBOURS = 5;

function useShownImage(image) {
  const [src, setSrc] = useState(typeof image === "string" ? image : null);
  useEffect(() => {
    if (!image || typeof image === "string" || !window.URL || !window.URL.createObjectURL) {
      setSrc(typeof image === "string" ? image : null);
      return undefined;
    }
    const objectUrl = window.URL.createObjectURL(image);
    setSrc(objectUrl);
    return () => window.URL.revokeObjectURL(objectUrl);
  }, [image]);
  return src;
}

const Tile = ({ name, src, fresh }) => (
  <li className={`cns-tile${fresh ? " cns-tile--new" : ""}`}>
    {src ? <img className="cns-tile__picture" src={src} alt={name} /> : <span className="cns-tile__letter">{name.charAt(0)}</span>}
    <span className="cns-tile__name">{name}</span>
  </li>
);

export default function CategoryTilePreview({ name, image, neighbours }) {
  const src = useShownImage(image);
  return (
    <ul className="cns-tiles" aria-label="Home row preview">
      <Tile name={name} src={src} fresh />
      {neighbours.slice(0, NEIGHBOURS).map((tile) => (
        <Tile key={tile.id} name={tile.name} src={tile.image} />
      ))}
    </ul>
  );
}
